/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="71.13"
        viewBox="0 0 95.58 71.13"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M54.69 0a1.86 1.86 0 0 1 1.81 1.72v15.77h-2.52v-15h-12.5v15h-2.5V1.86A1.84 1.84 0 0 1 40.73 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M60.36 16.24a1.24 1.24 0 0 1 1.23 1.26 1.26 1.26 0 0 1-1.09 1.23H35.22a1.27 1.27 0 0 1-1.23-1.28 1.25 1.25 0 0 1 1.1-1.21Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M40.29 9.43v2.5H7.55a5.06 5.06 0 0 0-5 4.83v46.76a5 5 0 0 0 4.83 5h80.71a5.07 5.07 0 0 0 5-4.83V17a5.06 5.06 0 0 0-4.83-5h-33V9.5H88a7.55 7.55 0 0 1 7.54 7.3v46.78a7.53 7.53 0 0 1-7.3 7.54H7.55A7.55 7.55 0 0 1 0 63.82V17a7.55 7.55 0 0 1 7.3-7.55h33Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M85.34 31.58a1.26 1.26 0 0 1 1.22 1.28 1.24 1.24 0 0 1-1.09 1.21H53.85a1.25 1.25 0 0 1-1.32-1.18 1.27 1.27 0 0 1 1.19-1.32h31.62ZM85.34 41a1.24 1.24 0 0 1 1.31 1.18 1.25 1.25 0 0 1-1.18 1.32H53.85a1.27 1.27 0 0 1-1.32-1.19A1.25 1.25 0 0 1 53.72 41ZM85.34 50.48a1.26 1.26 0 0 1 1.34 1.17A1.28 1.28 0 0 1 85.5 53H53.85a1.27 1.27 0 0 1-1.23-1.28 1.25 1.25 0 0 1 1.1-1.21h31.62Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M44.56 42.28a17.16 17.16 0 1 1-17.17-17.16 17.17 17.17 0 0 1 17.16 17.16"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M27.4 45.44a6.3 6.3 0 1 1 6.29-6.3 6.29 6.29 0 0 1-6.29 6.29m5.23.75a8.79 8.79 0 1 0-12.3-1.83 8.63 8.63 0 0 0 1.84 1.83 18.29 18.29 0 0 0-8.87 5.81 16.63 16.63 0 0 0 1.57 2l.16-.13a15.92 15.92 0 0 1 24.74 0 .62.62 0 0 0 .14.14 17.12 17.12 0 0 0 1.59-2 18.39 18.39 0 0 0-8.87-5.84"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'IdentificationBadgeIcon';

export default Icon;
